var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"justify":"center"}},_vm._l((_vm.screenshots),function(file){return _c('v-col',{key:file.id,staticClass:"pa-2",attrs:{"cols":"12","sm":"6","md":"4","lg":"3"}},[_c('v-img',{staticClass:"screenshot-image",attrs:{"src":file.image,"lazy-src":file.image,"contain":"","outlined":""}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }